import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';
import { useDevice } from 'app/agriculture/queries/devices/useDevice';
import { useMemo } from 'react';
import { StatusMessage } from 'app/agriculture/routes/Devices/utils/status/types';
import { checkLocator } from 'app/agriculture/routes/Devices/utils/status/locatorStatus/checkLocator';
import { aggregateStatusMessages } from 'app/agriculture/routes/Devices/utils/status/aggregateStatusMessages';
import { checkNetwork } from 'app/agriculture/routes/Devices/utils/status/networkStatus/checkNetwork';
import { checkPower } from 'app/agriculture/routes/Devices/utils/status/powerStatus/checkPower';

export function useLocatorStatus({ deviceId }: { deviceId: string }): StatusMessage {
    const device = useDevice({ deviceId });

    const heartbeatSnapshot = useSnapshot({
        parentId: deviceId,
        snapshotType: 'Heartbeat',
        shelfLife: { hours: 1 },
    });

    const networkSnapshot = useSnapshot({
        parentId: deviceId,
        snapshotType: 'Network',
        shelfLife: { hours: 1 },
    });

    const powerSnapshot = useSnapshot({
        parentId: deviceId,
        snapshotType: 'Power',
        shelfLife: { hours: 1 },
    });

    const recentLocationSnapshot = useSnapshot({
        parentId: deviceId,
        snapshotType: 'Location',
        shelfLife: { hours: 1 },
    });

    return useMemo(() => {
        if (device.deviceType === 'Personal Locator Beacon' && !heartbeatSnapshot) {
            return { status: 'expectedError', messages: [] };
        }

        return aggregateStatusMessages([
            checkNetwork({
                device,
                snapshots: {
                    Network: networkSnapshot,
                },
            }),
            checkPower({
                device,
                snapshots: {
                    Power: powerSnapshot,
                },
            }),
            checkLocator({
                device,
                snapshots: {
                    Location: recentLocationSnapshot,
                },
            }),
        ]);
    }, [device, heartbeatSnapshot, networkSnapshot, powerSnapshot, recentLocationSnapshot]);
}
